import React from "react";
import {
  TextField,
  Grid,
  Typography,
  MenuItem,
  Avatar,
  Box
} from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CompanyVeiwController from "../../../redux/actions/companyApiActions";


const EmployerInformationForm = ({ formik }) => {
  const { values, errors, touched, handleChange, handleBlur } = formik;
  const dispatch = useDispatch();
  const { getCompanies } = CompanyVeiwController();
  const { companies } = useSelector((state) => state.company);

  

useEffect(() => {
  dispatch(getCompanies());
}, [dispatch]);


  return (
    <>
      {/* <Typography variant="subtitle1" gutterBottom>
        Upload Profile Image (below 4 MB)
      </Typography>
      <input type="file" accept="image/*" /> */}

      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="First Name"
            name="first_name"
            value={values.first_name}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.first_name && Boolean(errors.first_name)}
            helperText={touched.first_name&& errors.first_name}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Last Name"
            name="last_name"
            value={values.last_name}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Email"
            name="email"
            value={values.email}
            onChange={handleChange}
            error={touched.email && Boolean(errors.email)}
            helperText={touched.email && errors.email}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Contact Number"
            name="mobile_number"
            value={values.mobile_number}
            onChange={handleChange}
            error={touched.mobile_number && Boolean(errors.mobile_number)}
            helperText={touched.mobile_number && errors.mobile_number}
          />
        </Grid>
        <Grid item xs={12}>
        <TextField
            select
            fullWidth
            label="Company"
            name="company"
            value={values.company}
            onChange={handleChange}
            error={touched.company && Boolean(errors.company)}
            helperText={touched.company && errors.company}
            >
            <MenuItem value="">Select Company</MenuItem>
            {companies.map((c) => (
            <MenuItem key={c.id} value={c.id}>
            {c.company_name}
            </MenuItem>
            ))}
            </TextField>
        </Grid>
        

        
      </Grid>
    </>
  );
};

export default EmployerInformationForm;
